import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import propTypes from 'prop-types';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useHistory } from 'react-router-dom';
import useRequest from '../../../../Hooks/useRequest';
import { StyledButton } from '../../../../Components/Generics.styled';

const WhichBestDescribesOfferCategoryContainer = styled.div`
    margin-top: 100px;
    display: flex;
    margin-left: auto;
    margin-right: auto;
    flex-direction: column;
`;

const Title = styled.div`
    font-size: 23px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    height: 50px;
    flex-direction: column;
    font-weight: bold;
    text-align: center;
`;

const DropdownApplet = styled.div`
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
    height: 100px;
    text-align: center;

    .MuiSelect-outlined.MuiSelect-outlined {
        background-color: #fafbf7;
    }
`;

const StyledNavButtons = styled.div`
    margin-top: 20px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 160px;
    margin-left: auto;
    margin-right: auto;
`;

const BackBtn = styled(Button)`
    background: #2e69fe 0% 0% no-repeat padding-box !important;
    box-shadow: 0px 3px 3px #00000061;
    border-radius: 4px;
    opacity: 1;
    height: 40px;
    color: #fafbf7;
`;

const NextBtn = styled(Button)`
    background: #2e69fe 0% 0% no-repeat padding-box !important;
    box-shadow: 0px 3px 3px #00000061;
    border-radius: 4px;
    opacity: 1;
    height: 40px;
    color: #fafbf7;

    &.MuiButton-contained.Mui-disabled {
        color: #fafbf7;
    }
    :disabled {
        background: #9b9b9d 0% 0% no-repeat padding-box !important;
    }
`;

const StyledSelect = styled(Select)`
    width: 300px;
    text-align: left;
`;

const WhichBestDescribesOfferCategory = (props) => {
    const { campaignData, setCampaignData, handleNavButtonNext } = props;
    const history = useHistory();
    const { data: campaignTypeData } = useRequest('/getAllCampaignTypes');
    const [campaignTypeCategories, setCampaignTypeCategories] = useState([]);

    const handleBackButton = () => {
        history.push('/portal/campaign/createACampaign');
    };

    useEffect(() => {
        if (campaignData.campaignTypeId !== 0) {
            const selectedCampaignType = campaignTypeData.find((item) => {
                if (item.campaignTypeId === campaignData?.campaignTypeId) {
                    return true;
                }
                return false;
            });
            setCampaignTypeCategories(selectedCampaignType.campaignTypeCategories);

            campaignTypeCategories.map((item) => {
                if (item.categoryName === campaignData.campaignTypeCategoryName) {
                    setCampaignData({
                        ...campaignData,
                        campaignTypeCategoryId: item.campaignTypeCategoryId,
                    });
                }
                return null;
            });
        }
    }, [campaignData.campaignTypeId, campaignData.campaignTypeCategoryName]);

    return (
        <WhichBestDescribesOfferCategoryContainer>
            <Title>Which best describes your offer category?</Title>
            <DropdownApplet>
                <FormControl variant="outlined">
                    <InputLabel id="select-category-dropdown">Select Category</InputLabel>
                    <StyledSelect
                        labelId="select-category-dropdown"
                        id="select-category-dropdown-outlined"
                        value={campaignData?.campaignTypeCategoryName}
                        onChange={(e) =>
                            setCampaignData({
                                ...campaignData,
                                campaignTypeCategoryName: e.target.value,
                            })
                        }
                        label="Select Category"
                    >
                        {campaignTypeCategories?.map((item, idx) => {
                            return (
                                <MenuItem key={idx} value={item.categoryName}>
                                    {item.categoryName}
                                </MenuItem>
                            );
                        })}
                    </StyledSelect>
                </FormControl>
            </DropdownApplet>
            <StyledNavButtons>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleBackButton()}
                >
                    Back
                </StyledButton>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleNavButtonNext()}
                    disabled={campaignData?.campaignTypeCategoryName === ''}
                >
                    Next
                </StyledButton>
            </StyledNavButtons>
        </WhichBestDescribesOfferCategoryContainer>
    );
};

WhichBestDescribesOfferCategory.propTypes = {
    campaignData: propTypes.shape({
        campaignTypeCategoryId: propTypes.number,
        campaignTypeId: propTypes.number,
        campaignTypeCategoryName: propTypes.string,
    }),
    setCampaignData: propTypes.func,
    handleNavButtonNext: propTypes.func,
};

WhichBestDescribesOfferCategory.defaultProps = {
    campaignData: { categoryId: '', category: '' },
    setCampaignData: () => {},
    handleNavButtonNext: () => {},
};
export default WhichBestDescribesOfferCategory;
